export default __webpack_public_path__ + "static/media/kartu-7.f80748ff.jpg";